// stock-register.js

(() => {
  if (window.lnfNotifications || window.__lnfNotificationsInitialized || window.__lnfNotificationsLoading) return;
  const existing = document.querySelector('script[data-lnf-notifications]');
  if (existing) return;
  const script = document.createElement('script');
  script.src = 'notifications.js';
  script.defer = true;
  script.dataset.lnfNotifications = '1';
  window.__lnfNotificationsLoading = true;
  script.addEventListener('load', () => {
    window.__lnfNotificationsLoading = false;
  });
  script.addEventListener('error', () => {
    window.__lnfNotificationsLoading = false;
  });
  document.head.appendChild(script);
})();

async function jsonFetch(url, options = {}) {
  const token = localStorage.getItem('lnf_token');
  const baseHeaders = { 'Content-Type': 'application/json' };
  if (token) baseHeaders.Authorization = `Bearer ${token}`;
  const method = String(options.method || 'GET').toUpperCase();
  const response = await fetch(url, {
    ...options,
    ...(method === 'GET' && options.cache === undefined ? { cache: 'no-store' } : {}),
    headers: { ...baseHeaders, ...(options.headers || {}) }
  });
  if (!response.ok) {
    const text = await response.text();
    let message = text || `Request failed: ${response.status}`;
    try {
      const parsed = JSON.parse(text);
      if (parsed?.error) message = parsed.error;
    } catch (_err) {
      // keep fallback text
    }
    throw new Error(message);
  }
  return response.status === 204 ? null : response.json();
}

document.addEventListener('DOMContentLoaded', () => {
  const stockSelectorPanel = document.getElementById('stockSelectorPanel');
  const stockSpecialtyGrid = document.getElementById('stockSpecialtyGrid');
  const stockSelectorStatus = document.getElementById('stockSelectorStatus');
  const stockMatchSummary = document.getElementById('stockMatchSummary');
  const changeStockSelectionBtn = document.getElementById('changeStockSelectionBtn');
  const stockFloatingActions = document.getElementById('stockFloatingActions');

  const stockLocationModal = document.getElementById('stockLocationModal');
  const stockLocationSelect = document.getElementById('stockLocationSelect');
  const stockLocationStatus = document.getElementById('stockLocationStatus');
  const closeStockLocationModal = document.getElementById('closeStockLocationModal');
  const cancelStockLocationBtn = document.getElementById('cancelStockLocationBtn');
  const stockConfirmLocationBtn = document.getElementById('stockConfirmLocationBtn');
  const stockUseCurrentLocationBtn = document.getElementById('stockUseCurrentLocationBtn');

  const resultSections = Array.from(document.querySelectorAll('.stock-results-section'));

  const currentTable = document.getElementById('currentStockTable');
  const currentBody = document.querySelector('#currentStockTable tbody');
  const currentStatus = document.getElementById('currentStockStatus');
  const currentSearch = document.getElementById('currentStockSearch');
  const currentNodeSelect = document.getElementById('currentNodeSelect');
  const stockCategoryFilter = document.getElementById('stockCategoryFilter');
  const stockTypeFilter = document.getElementById('stockTypeFilter');
  const clearStockFiltersBtn = document.getElementById('clearStockFiltersBtn');

  const exchangeTable = document.getElementById('exchangeTable');
  const exchangeBody = document.querySelector('#exchangeTable tbody');
  const exchangeStatus = document.getElementById('exchangeStatus');
  const exchangeSearch = document.getElementById('exchangeSearch');
  const exchangeNodeSelect = document.getElementById('exchangeNodeSelect');

  const orderModal = document.getElementById('orderModal');
  const openOrderBtn = document.getElementById('openOrderModal');
  const orderCartCount = document.getElementById('orderCartCount');
  const orderForm = document.getElementById('orderForm');
  const orderStatus = document.getElementById('orderStatus');
  const orderAuthNote = document.getElementById('orderAuthNote');
  const orderItemSearch = document.getElementById('orderItemSearch');
  const orderCategoryFilter = document.getElementById('orderCategoryFilter');
  const orderTypeFilter = document.getElementById('orderTypeFilter');
  const orderItemSelect = document.getElementById('orderItemSelect');
  const orderQuantityInput = document.getElementById('orderQuantityInput');
  const orderItemNotes = document.getElementById('orderItemNotes');
  const orderItemsList = document.getElementById('orderItemsList');
  const orderCartSummary = document.getElementById('orderCartSummary');
  const orderCartTotalPrice = document.getElementById('orderCartTotalPrice');
  const orderCartTotalLandUseUnits = document.getElementById('orderCartTotalLandUseUnits');
  const orderCartPricingNote = document.getElementById('orderCartPricingNote');
  const addOrderItemBtn = document.getElementById('addOrderItemBtn');
  const orderReferralSource = document.getElementById('orderReferralSource');
  const orderReferralMemberField = document.getElementById('orderReferralMemberField');
  const orderReferralMemberName = document.getElementById('orderReferralMemberName');

  if (!stockSpecialtyGrid || !stockLocationSelect || !currentBody || !exchangeBody) return;

  const nodeSpecializations = window.LNFNodeSpecializations || {};
  const stockCatalogRaw = nodeSpecializations.SPECIALIZATION_CATALOG?.stock || [];
  const stockCatalog = stockCatalogRaw;
  const normalizeLookupText = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s*&\s*/g, ' & ')
    .replace(/\band\b/g, ' & ')
    .replace(/\s+/g, ' ')
    .trim();
  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
  const stockCategoryLabelByKey = new Map();
  const stockTypeLabelByKey = new Map();
  const stockTypeCategoryByKey = new Map();
  stockCatalog.forEach((group) => {
    const categoryLabel = String(group?.category || '').trim();
    const categoryKey = normalizeLookupText(categoryLabel);
    if (categoryKey && !stockCategoryLabelByKey.has(categoryKey)) {
      stockCategoryLabelByKey.set(categoryKey, categoryLabel);
    }
    (group?.options || []).forEach((option) => {
      const optionLabel = String(option || '').trim();
      const optionKey = normalizeLookupText(optionLabel);
      if (optionKey && !stockTypeLabelByKey.has(optionKey)) {
        stockTypeLabelByKey.set(optionKey, optionLabel);
      }
      if (optionKey && categoryLabel && !stockTypeCategoryByKey.has(optionKey)) {
        stockTypeCategoryByKey.set(optionKey, categoryLabel);
      }
    });
  });
  const normalizeKey = (value) => normalizeLookupText(value);
  const canonicalizeStockCategoryLabel = (value) => {
    const label = String(value || '').trim();
    if (!label) return '';
    return stockCategoryLabelByKey.get(normalizeLookupText(label)) || label;
  };
  const sanitizeStockTypeLabel = (value) => String(value || '')
    .trim()
    .replace(/\s*[:\-]\s*\d+(?:\.\d+)?\s*$/g, '')
    .replace(/\s+\d+(?:\.\d+)?\s*$/g, '')
    .trim();
  const canonicalizeStockTypeLabel = (value) => {
    const label = sanitizeStockTypeLabel(value);
    if (!label) return '';
    return stockTypeLabelByKey.get(normalizeLookupText(label)) || label;
  };
  const nodeSupportsMode = typeof nodeSpecializations.nodeSupportsMode === 'function'
    ? nodeSpecializations.nodeSupportsMode
    : (node, mode) => {
        const type = String(node?.node_type || 'hybrid').trim().toLowerCase();
        if (mode === 'stock') return type === 'stock' || type === 'hybrid';
        if (mode === 'install') return type === 'install' || type === 'hybrid';
        return false;
      };
  const normalizeNodeSpecialties = typeof nodeSpecializations.normalizeNodeSpecialties === 'function'
    ? nodeSpecializations.normalizeNodeSpecialties
    : (raw) => {
        if (!Array.isArray(raw)) return [];
        return raw
          .map((entry) => {
            const category = String(entry?.category || '').trim();
            const options = Array.isArray(entry?.options)
              ? entry.options.map((label) => String(label || '').trim()).filter(Boolean)
              : [];
            if (!category || !options.length) return null;
            return { category, options };
          })
          .filter(Boolean);
      };
  const nodeMatchesSpecialty = typeof nodeSpecializations.nodeMatchesSpecialty === 'function'
    ? nodeSpecializations.nodeMatchesSpecialty
    : (node, cfg = {}) => {
        const categoryKey = normalizeKey(cfg.category || '');
        const optionKey = normalizeKey(cfg.option || '');
        const mode = cfg.mode === 'install' ? 'install' : 'stock';
        const raw = mode === 'install'
          ? (node?.install_specialties || [])
          : (node?.stock_specialties || []);
        const specialties = normalizeNodeSpecialties(raw, mode);
        if (!specialties.length) return false;
        return specialties.some((group) => {
          const groupCategoryKey = normalizeKey(group?.category || '');
          if (categoryKey && groupCategoryKey !== categoryKey) return false;
          return (group?.options || []).some((label) => normalizeKey(label) === optionKey);
        });
      };
  const nodeSupportsStockDirectory = (node) => {
    if (nodeSupportsMode(node, 'stock')) return true;
    const stockSpecialties = normalizeNodeSpecialties(
      node?.stock_specialties || [],
      'stock'
    );
    return stockSpecialties.length > 0;
  };
  const toSlug = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  const CATEGORY_DISPLAY_ORDER = {
    stock: [
      'Choice Plants',
      'Native Plants',
      'Trees & Bushes',
      'Produce/Food',
      'Flowers',
      'Landscaping Materials',
      'Tools'
    ],
    install: [
      'Full Property Design',
      'Maintenance',
      'Trees',
      'Ecosystem Restoration',
      'Soil Building',
      'Water Systems'
    ]
  };
  const buildCatalogWithConfiguredSpecialties = (baseCatalog, nodes, mode, { includeBaseCatalog = true } = {}) => {
    const categoryMap = new Map();
    const baseOrder = [];

    const ensureCategory = (categoryLabel, isBase = false) => {
      const finalCategory = String(categoryLabel || '').trim() || 'Custom';
      const key = normalizeKey(finalCategory);
      if (!categoryMap.has(key)) {
        categoryMap.set(key, {
          category: finalCategory,
          options: [],
          optionSet: new Set()
        });
      }
      const row = categoryMap.get(key);
      if (isBase && !baseOrder.includes(key)) baseOrder.push(key);
      return row;
    };

    const addOption = (row, optionLabel) => {
      const label = String(optionLabel || '').trim();
      if (!label) return;
      const key = normalizeKey(label);
      if (row.optionSet.has(key)) return;
      row.optionSet.add(key);
      row.options.push(label);
    };

    (Array.isArray(baseCatalog) ? baseCatalog : []).forEach((group) => {
      const categoryLabel = group?.category || '';
      if (includeBaseCatalog) {
        const row = ensureCategory(categoryLabel, true);
        (group?.options || []).forEach((label) => addOption(row, label));
        return;
      }
      const key = normalizeKey(categoryLabel);
      if (key && !baseOrder.includes(key)) baseOrder.push(key);
    });

    (Array.isArray(nodes) ? nodes : []).forEach((node) => {
      const raw = mode === 'install'
        ? (node?.install_specialties || [])
        : (node?.stock_specialties || []);
      const specialties = normalizeNodeSpecialties(raw, mode);
      specialties.forEach((group) => {
        const row = ensureCategory(group?.category || '', false);
        (group?.options || []).forEach((label) => addOption(row, label));
      });
    });

    const used = new Set();
    const out = [];
    baseOrder.forEach((key) => {
      const row = categoryMap.get(key);
      if (!row || !row.options.length) return;
      out.push({ category: row.category, options: row.options.slice() });
      used.add(key);
    });

    const extras = Array.from(categoryMap.entries())
      .filter(([key, row]) => !used.has(key) && row.options.length)
      .map(([, row]) => ({ category: row.category, options: row.options.slice() }))
      .sort((a, b) => a.category.localeCompare(b.category));

    const merged = out.concat(extras);
    const desiredOrder = CATEGORY_DISPLAY_ORDER[mode] || [];
    if (!desiredOrder.length) return merged;
    const orderIndex = new Map(desiredOrder.map((category, idx) => [normalizeKey(category), idx]));
    return merged.sort((a, b) => {
      const aIndex = orderIndex.has(normalizeKey(a?.category || ''))
        ? orderIndex.get(normalizeKey(a?.category || ''))
        : Number.MAX_SAFE_INTEGER;
      const bIndex = orderIndex.has(normalizeKey(b?.category || ''))
        ? orderIndex.get(normalizeKey(b?.category || ''))
        : Number.MAX_SAFE_INTEGER;
      if (aIndex !== bIndex) return aIndex - bIndex;
      if (aIndex !== Number.MAX_SAFE_INTEGER) return 0;
      return String(a?.category || '').localeCompare(String(b?.category || ''));
    });
  };

  let displayStockCatalog = buildCatalogWithConfiguredSpecialties(stockCatalog, [], 'stock', { includeBaseCatalog: true });
  let specialtyById = new Map();
  const locationAreaByKey = new Map();

  let allCurrent = [];
  let allExchange = [];
  let nodesCache = [];
  let locationAreas = [];
  let activeNodeId = null;
  let pendingSpecialty = null;
  let selectedSpecialty = null;
  let selectedArea = null;
  let selectedStockNeed = null;
  let applyNeedFiltersOnNextLoad = false;
  let matchedNode = null;
  let orderCartItems = [];
  const ORDER_CART_STORAGE_KEY = 'lnf_order_cart_by_node_v1';
  const REFERRAL_SOURCE_EXISTING_MEMBER = 'existing-member';
  const STOCK_LAND_USE_UNIT_USD = 1000;
  const STOCK_DISPLAY_DECIMALS = 12;
  const ORDER_FOLLOW_UP_MESSAGE = 'Order request received. A member will review availability and follow up within 24 to 48 hours to confirm pickup or delivery. Orders are paid in person on pickup or delivery, not through the app.';
  const tableLabelCache = new WeakMap();

  let highlightTarget = null;
  let highlightApplied = false;
  let queryResultsBootstrapped = false;

  const params = new URLSearchParams(window.location.search);
  const queryNode = params.get('node_id') || '';
  const queryCategory = params.get('category') || '';
  const queryType = params.get('type') || '';
  const queryFocus = String(params.get('focus') || '').trim().toLowerCase();
  const hasFocusFlag = queryFocus === '1' || queryFocus === 'true' || queryFocus === 'yes';
  const queryItem = params.get('item') || params.get('q') || '';
  const shouldOpenResultsFromQuery = Boolean(queryItem || queryCategory || queryType || hasFocusFlag);
  let applyQueryFiltersOnNextLoad = Boolean(queryCategory || queryType);
  if (queryItem) {
    highlightTarget = String(queryItem || '').trim().toLowerCase();
    if (!queryCategory && !queryType && currentSearch) currentSearch.value = queryItem;
  }

  const normalizeName = (value) => String(value || '').trim().toLowerCase();
  const normalizeText = (value) => normalizeLookupText(value);
  const getOrderCartNodeKey = () => (activeNodeId ? `node:${String(activeNodeId)}` : 'node:all');
  const normalizeStockDecimal = (value) => {
    if (!Number.isFinite(value)) return null;
    return Number.parseFloat(value.toPrecision(15));
  };
  const parsePriceUsd = (value) => {
    const raw = String(value === undefined || value === null ? '' : value)
      .replace(/[$,]/g, '')
      .trim();
    if (!raw) return null;
    const num = Number(raw);
    if (!Number.isFinite(num) || num < 0) return null;
    return normalizeStockDecimal(num);
  };
  const parseLandUseUnits = (value) => {
    const raw = String(value === undefined || value === null ? '' : value).trim();
    if (!raw) return null;
    const num = Number(raw);
    if (!Number.isFinite(num) || num < 0) return null;
    return normalizeStockDecimal(num);
  };
  const normalizePricingSnapshot = (rawPrice, rawUnits) => {
    const explicitPrice = parsePriceUsd(rawPrice);
    const explicitUnits = parseLandUseUnits(rawUnits);
    const priceUsd = explicitPrice !== null
      ? explicitPrice
      : (explicitUnits !== null ? parsePriceUsd(explicitUnits * STOCK_LAND_USE_UNIT_USD) : null);
    const landUseUnits = priceUsd !== null
      ? parseLandUseUnits(priceUsd / STOCK_LAND_USE_UNIT_USD)
      : explicitUnits;
    return { priceUsd, landUseUnits };
  };
  const extractEmbeddedStockCount = (rawFormLabel) => {
    const raw = String(rawFormLabel || '').trim();
    if (!raw) return {
      form: '',
      stock_left: null
    };

    const parenMatch = raw.match(/^(.*?)(?:\s*\(\s*(\d+(?:\.\d+)?)\s*\))$/);
    if (parenMatch) {
      return {
        form: String(parenMatch[1] || '').trim(),
        stock_left: toStockCount(parenMatch[2])
      };
    }

    const suffixMatch = raw.match(/^(.*?)(?:\s*[:\-]\s*(\d+(?:\.\d+)?))$/);
    if (suffixMatch) {
      return {
        form: String(suffixMatch[1] || '').trim(),
        stock_left: toStockCount(suffixMatch[2])
      };
    }

    return {
      form: raw,
      stock_left: null
    };
  };
  const parseOrderQuantity = (value) => {
    const raw = String(value === undefined || value === null ? '' : value).trim();
    if (!raw) return null;
    const num = Number(raw);
    if (!Number.isFinite(num) || num <= 0) return null;
    return Math.max(1, Math.round(num));
  };
  const normalizeCartItems = (rawItems) => {
    if (!Array.isArray(rawItems)) return [];
    return rawItems
      .map((entry) => {
        const item = String(entry?.item || '').trim();
        const form = String(entry?.form || '').trim();
        const quantityValue = parseOrderQuantity(entry?.quantity);
        const notes = String(entry?.notes || '').trim();
        const nodeId = entry?.node_id ?? null;
        const nodeName = String(entry?.node_name || '').trim();
        const choiceKey = String(entry?.choice_key || '').trim();
        const pricing = normalizePricingSnapshot(
          entry?.price_usd,
          entry?.land_use_units
        );
        if (!item) return null;
        return {
          item,
          form: form || null,
          quantity: String(quantityValue || 1),
          notes: notes || null,
          node_id: nodeId === undefined || nodeId === null || String(nodeId).trim() === '' ? null : nodeId,
          node_name: nodeName || null,
          choice_key: choiceKey || null,
          price_usd: pricing.priceUsd,
          land_use_units: pricing.landUseUnits
        };
      })
      .filter(Boolean);
  };
  const readOrderCartStorage = () => {
    try {
      const raw = localStorage.getItem(ORDER_CART_STORAGE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
      return parsed;
    } catch (_err) {
      return {};
    }
  };
  const writeOrderCartStorage = (payload) => {
    try {
      localStorage.setItem(ORDER_CART_STORAGE_KEY, JSON.stringify(payload || {}));
    } catch (_err) {
      // ignore quota/storage errors
    }
  };
  const loadOrderCartForActiveNode = () => {
    const key = getOrderCartNodeKey();
    const stored = readOrderCartStorage();
    orderCartItems = normalizeCartItems(stored?.[key]);
  };
  const persistOrderCartForActiveNode = () => {
    const key = getOrderCartNodeKey();
    const stored = readOrderCartStorage();
    if (orderCartItems.length) {
      stored[key] = orderCartItems.map((entry) => ({
        item: entry.item,
        form: entry.form || null,
        quantity: entry.quantity,
        notes: entry.notes || null,
        node_id: entry.node_id ?? null,
        node_name: entry.node_name || null,
        choice_key: entry.choice_key || null,
        price_usd: entry.price_usd ?? null,
        land_use_units: entry.land_use_units ?? null
      }));
    } else {
      delete stored[key];
    }
    writeOrderCartStorage(stored);
  };
  const normalizeStockCategories = (rawCategories, rawCategory) => {
    const source = [];
    if (Array.isArray(rawCategories)) source.push(...rawCategories);
    else if (typeof rawCategories === 'string' && rawCategories.trim()) {
      const trimmed = rawCategories.trim();
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) source.push(...parsed);
        else source.push(...trimmed.split(/[;,]/g));
      } catch (_err) {
        source.push(...trimmed.split(/[;,]/g));
      }
    }
    if (Array.isArray(rawCategory)) source.push(...rawCategory);
    else if (typeof rawCategory === 'string' && rawCategory.trim()) source.push(...rawCategory.split(/[;,]/g));

    const dedupe = new Set();
    const out = [];
    source.forEach((entry) => {
      const label = canonicalizeStockCategoryLabel(entry);
      if (!label) return;
      const key = normalizeText(label);
      if (!key || dedupe.has(key)) return;
      dedupe.add(key);
      out.push(label);
    });
    return out;
  };
  const normalizeStockTypes = (rawTypes, rawType) => {
    const source = [];
    if (Array.isArray(rawTypes)) source.push(...rawTypes);
    else if (typeof rawTypes === 'string' && rawTypes.trim()) {
      const trimmed = rawTypes.trim();
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) source.push(...parsed);
        else source.push(...trimmed.split(/[;,]/g));
      } catch (_err) {
        source.push(...trimmed.split(/[;,]/g));
      }
    }
    if (Array.isArray(rawType)) source.push(...rawType);
    else if (typeof rawType === 'string' && rawType.trim()) source.push(...rawType.split(/[;,]/g));

    const dedupe = new Set();
    const out = [];
    source.forEach((entry) => {
      const label = canonicalizeStockTypeLabel(entry);
      if (!label) return;
      const key = normalizeText(label);
      if (!key || dedupe.has(key)) return;
      dedupe.add(key);
      out.push(label);
    });
    return out;
  };
  const normalizeStockForms = (rawForms, rawForm) => {
    const source = [];
    if (Array.isArray(rawForms)) source.push(...rawForms);
    else if (typeof rawForms === 'string' && rawForms.trim()) {
      const trimmed = rawForms.trim();
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) source.push(...parsed);
        else source.push(...trimmed.split(/[;,]/g));
      } catch (_err) {
        source.push(...trimmed.split(/[;,]/g));
      }
    }
    if (Array.isArray(rawForm)) source.push(...rawForm);
    else if (typeof rawForm === 'string' && rawForm.trim()) source.push(...rawForm.split(/[;,]/g));

    const dedupe = new Set();
    const out = [];
    source.forEach((entry) => {
      const label = String(entry || '').trim();
      if (!label) return;
      const key = normalizeText(label);
      if (!key || dedupe.has(key)) return;
      dedupe.add(key);
      out.push(label);
    });
    return out;
  };
  const toStockCount = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num) || num < 0) return 0;
    return Math.round(num);
  };
  const STOCK_TYPES_ALWAYS_LAST = new Set(['seeds', 'potted plants']);
  const isTrailingStockType = (label) => STOCK_TYPES_ALWAYS_LAST.has(normalizeText(label));
  const orderStockTypeLabels = (labels = []) => {
    const regular = [];
    const trailing = [];
    labels.forEach((label) => {
      const clean = String(label || '').trim();
      if (!clean) return;
      if (isTrailingStockType(clean)) trailing.push(clean);
      else regular.push(clean);
    });
    return regular.concat(trailing);
  };
  const normalizeStockFormEntries = (rawEntries) => {
    const source = Array.isArray(rawEntries) ? rawEntries : [];
    const order = [];
    const byForm = new Map();
    const upsert = (rawEntry = {}) => {
      const parsedForm = extractEmbeddedStockCount(rawEntry?.form || rawEntry?.label || '');
      const form = parsedForm.form;
      if (!form) return;
      const key = normalizeText(form);
      if (!key) return;
      const explicitStockLeft = rawEntry?.stock_left;
      const hasExplicitStockLeft = explicitStockLeft !== undefined && explicitStockLeft !== null && String(explicitStockLeft).trim() !== '';
      const explicitStockCount = hasExplicitStockLeft ? toStockCount(explicitStockLeft) : null;
      const stockLeft = explicitStockCount === null
        ? (parsedForm.stock_left ?? 0)
        : (explicitStockCount === 0 && parsedForm.stock_left !== null ? parsedForm.stock_left : explicitStockCount);
      const pricing = normalizePricingSnapshot(rawEntry?.price_usd, rawEntry?.land_use_units);
      if (!byForm.has(key)) {
        byForm.set(key, {
          form,
          stock_left: 0,
          price_usd: pricing.priceUsd,
          land_use_units: pricing.landUseUnits
        });
        order.push(key);
      }
      const row = byForm.get(key);
      row.stock_left += stockLeft;
      if (pricing.priceUsd !== null) row.price_usd = pricing.priceUsd;
      if (pricing.landUseUnits !== null) row.land_use_units = pricing.landUseUnits;
      const normalizedPricing = normalizePricingSnapshot(row.price_usd, row.land_use_units);
      row.price_usd = normalizedPricing.priceUsd;
      row.land_use_units = normalizedPricing.landUseUnits;
    };

    source.forEach((entry) => {
      if (!entry || typeof entry !== 'object' || Array.isArray(entry)) return;
      upsert(entry);
    });

    return order.map((key) => byForm.get(key));
  };
  const dedupeLabels = (values = []) => {
    const seen = new Set();
    const out = [];
    values.forEach((value) => {
      const label = String(value || '').trim();
      if (!label) return;
      const key = normalizeText(label);
      if (!key || seen.has(key)) return;
      seen.add(key);
      out.push(label);
    });
    return out;
  };
  const getItemTypes = (item) => {
    return normalizeStockTypes(item?.types, item?.type);
  };
  const getItemFormEntries = (item) => normalizeStockFormEntries(item?.form_entries);
  const getItemForms = (item) => getItemFormEntries(item).map((entry) => entry.form);
  const getItemCategories = (item) => {
    const directCategories = normalizeStockCategories(item?.categories, item?.category);
    if (directCategories.length) return directCategories;
    const inferredCategories = getItemTypes(item)
      .map((type) => stockTypeCategoryByKey.get(normalizeText(type)))
      .filter(Boolean);
    return dedupeLabels(inferredCategories);
  };
  const formatItemForms = (item) => {
    const entries = getItemFormEntries(item);
    if (!entries.length) return '';
    const pills = entries
      .map((entry) => ({
        form: String(entry?.form || '').trim(),
        count: toStockCount(entry?.stock_left)
      }))
      .filter((entry) => entry.form)
      .map((entry) => `<span class="pill-sky">${escapeHtml(`${entry.form}:${entry.count}`)}</span>`);
    return pills.length ? `<div class="pill-row">${pills.join('')}</div>` : '';
  };
  const formatItemPrices = (item) => {
    const entries = getItemFormEntries(item);
    if (!entries.length) return '';
    const pills = entries
      .map((entry) => ({
        form: String(entry?.form || '').trim(),
        price: formatPriceDisplay(entry?.price_usd) || '—'
      }))
      .filter((entry) => entry.form)
      .map((entry) => `<span class="pill-green">${escapeHtml(`${entry.form} ${entry.price}`)}</span>`);
    return pills.length ? `<div class="pill-row">${pills.join('')}</div>` : '';
  };
  const formatItemLandUseUnits = (item) => {
    const entries = getItemFormEntries(item);
    if (!entries.length) return '';
    const pills = entries
      .map((entry) => ({
        form: String(entry?.form || '').trim(),
        land_use_units: formatLandUseUnitsDisplay(entry?.land_use_units) || '—'
      }))
      .filter((entry) => entry.form)
      .map((entry) => `<span class="pill-soft">${escapeHtml(`${entry.form} ${entry.land_use_units} LU`)}</span>`);
    return pills.length ? `<div class="pill-row">${pills.join('')}</div>` : '';
  };
  const getAvailableOrderChoices = () => {
    const byKey = new Map();
    allCurrent.forEach((item) => {
      const name = String(item?.item || '').trim();
      const nodeIdRaw = item?.node_id;
      const nodeId = nodeIdRaw === undefined || nodeIdRaw === null || String(nodeIdRaw).trim() === '' ? null : String(nodeIdRaw).trim();
      const nodeName = String(item?.node_name || '').trim() || 'Global Listing';
      if (!name) return;
      const categories = getItemCategories(item);
      const types = getItemTypes(item);
      getItemFormEntries(item).forEach((formEntry) => {
        const form = String(formEntry?.form || '').trim();
        if (!form) return;
        const available = toStockCount(formEntry.stock_left);
        if (available <= 0) return;
        const key = activeNodeId
          ? `item:${normalizeText(name)}::form:${normalizeText(form)}`
          : `item:${normalizeText(name)}::form:${normalizeText(form)}::node:${nodeId || normalizeText(nodeName)}`;
        const pricing = normalizePricingSnapshot(formEntry.price_usd, formEntry.land_use_units);
        if (!byKey.has(key)) {
          byKey.set(key, {
            key,
            name,
            form,
            node_id: nodeId,
            node_name: nodeName,
            available,
            categories,
            types,
            price_usd: pricing.priceUsd,
            land_use_units: pricing.landUseUnits
          });
          return;
        }
        const existing = byKey.get(key);
        existing.available += available;
        existing.categories = dedupeLabels(existing.categories.concat(categories));
        existing.types = dedupeLabels(existing.types.concat(types));
        if (pricing.priceUsd !== null) existing.price_usd = pricing.priceUsd;
        if (pricing.landUseUnits !== null) existing.land_use_units = pricing.landUseUnits;
      });
    });
    return Array.from(byKey.values()).sort((a, b) => {
      const byName = a.name.localeCompare(b.name);
      if (byName !== 0) return byName;
      const byForm = String(a.form || '').localeCompare(String(b.form || ''));
      if (byForm !== 0) return byForm;
      return String(a.node_name || '').localeCompare(String(b.node_name || ''));
    });
  };
  const getOrderChoiceSearchText = (choice) => normalizeText([choice?.name || '', choice?.form || '', choice?.node_name || ''].join(' '));
  const formatOrderChoiceLabel = (choice) => {
    const item = String(choice?.name || '').trim();
    const form = String(choice?.form || '').trim();
    const itemLabel = form ? `${item} - ${form}` : item;
    if (activeNodeId) return itemLabel;
    const nodeLabel = String(choice?.node_name || '').trim();
    return nodeLabel ? `${itemLabel} - ${nodeLabel}` : itemLabel;
  };
  const createAvailableOrderChoiceLookups = (choices = getAvailableOrderChoices()) => {
    const byChoiceKey = new Map();
    const byName = new Map();
    choices.forEach((choice) => {
      const choiceKey = String(choice?.key || '').trim();
      if (choiceKey) byChoiceKey.set(choiceKey, choice);
      const nameKey = normalizeText(choice?.name || '');
      if (!nameKey) return;
      if (!byName.has(nameKey)) byName.set(nameKey, []);
      byName.get(nameKey).push(choice);
    });
    return { choices, byChoiceKey, byName };
  };
  const findMatchingOrderChoiceForEntry = (entry, lookups = createAvailableOrderChoiceLookups()) => {
    const choiceKey = String(entry?.choice_key || '').trim();
    if (choiceKey && lookups.byChoiceKey.has(choiceKey)) {
      return lookups.byChoiceKey.get(choiceKey);
    }
    const candidates = lookups.byName.get(normalizeText(entry?.item || '')) || [];
    if (!candidates.length) return null;
    const entryForm = normalizeText(entry?.form || '');
    const formMatches = entryForm
      ? candidates.filter((choice) => normalizeText(choice?.form || '') === entryForm)
      : candidates;
    if (!formMatches.length) return null;
    if (activeNodeId) return formMatches[0] || null;
    const entryNodeId = entry?.node_id === undefined || entry?.node_id === null ? '' : String(entry.node_id).trim();
    const entryNodeName = normalizeText(entry?.node_name || '');
    return formMatches.find((choice) => String(choice?.node_id || '').trim() === entryNodeId)
      || formMatches.find((choice) => normalizeText(choice?.node_name || '') === entryNodeName)
      || (formMatches.length === 1 ? formMatches[0] : null);
  };
  const resolveOrderCartEntryPricing = (entry, lookups = createAvailableOrderChoiceLookups()) => {
    const snapshot = normalizePricingSnapshot(
      entry?.price_usd,
      entry?.land_use_units
    );
    if (snapshot.priceUsd !== null || snapshot.landUseUnits !== null) {
      return snapshot;
    }
    const match = findMatchingOrderChoiceForEntry(entry, lookups);
    if (!match) return { priceUsd: null, landUseUnits: null };
    return normalizePricingSnapshot(match.price_usd, match.land_use_units);
  };
  const calculateOrderCartTotals = (lookups = createAvailableOrderChoiceLookups()) => {
    let totalPriceUsd = 0;
    let totalLandUseUnits = 0;
    let itemsMissingPricing = 0;
    orderCartItems.forEach((entry) => {
      const quantity = parseOrderQuantity(entry?.quantity) || 1;
      const pricing = resolveOrderCartEntryPricing(entry, lookups);
      if (pricing.priceUsd === null && pricing.landUseUnits === null) {
        itemsMissingPricing += 1;
        return;
      }
      if (pricing.priceUsd !== null) totalPriceUsd += pricing.priceUsd * quantity;
      if (pricing.landUseUnits !== null) totalLandUseUnits += pricing.landUseUnits * quantity;
    });
    return {
      totalPriceUsd: parsePriceUsd(totalPriceUsd) ?? 0,
      totalLandUseUnits: parseLandUseUnits(totalLandUseUnits) ?? 0,
      itemsMissingPricing
    };
  };
  const renderOrderCartSummary = (lookups = createAvailableOrderChoiceLookups()) => {
    const totals = calculateOrderCartTotals(lookups);
    if (orderCartSummary) {
      orderCartSummary.classList.toggle('is-empty', orderCartItems.length === 0);
    }
    if (orderCartTotalPrice) {
      orderCartTotalPrice.textContent = formatPriceDisplay(totals.totalPriceUsd) || '$0.00';
    }
    if (orderCartTotalLandUseUnits) {
      orderCartTotalLandUseUnits.textContent = formatLandUseUnitsDisplay(totals.totalLandUseUnits) || '0';
    }
    if (orderCartPricingNote) {
      const hasMissingPricing = totals.itemsMissingPricing > 0;
      orderCartPricingNote.classList.toggle('is-hidden', !hasMissingPricing);
      orderCartPricingNote.textContent = hasMissingPricing
        ? `${totals.itemsMissingPricing === 1 ? 'One item is' : `${totals.itemsMissingPricing} items are`} missing pricing, so totals may be incomplete.`
        : '';
    }
  };
  const isOrderUserSignedIn = () => {
    if (window.lnfAuthGate && typeof window.lnfAuthGate.isLoggedIn === 'function') {
      return window.lnfAuthGate.isLoggedIn();
    }
    return Boolean(localStorage.getItem('lnf_token'));
  };
  const showOrderSignIn = () => {
    if (window.lnfAuthGate && typeof window.lnfAuthGate.show === 'function') {
      window.lnfAuthGate.show();
    }
  };
  const focusOrderField = (field) => {
    if (!field || typeof field.focus !== 'function') return;
    try {
      field.focus({ preventScroll: true });
    } catch (_err) {
      field.focus();
    }
  };
  const getOrderChoiceMatchesFilters = (choice, { searchTerm = '', category = '', type = '' } = {}) => {
    const searchKey = normalizeText(searchTerm);
    const categoryKey = normalizeText(category);
    const typeKey = normalizeText(type);

    if (searchKey && !getOrderChoiceSearchText(choice).includes(searchKey)) return false;
    if (categoryKey) {
      const categoryKeys = (choice?.categories || []).map((value) => normalizeText(value));
      if (!categoryKeys.includes(categoryKey)) return false;
    }
    if (typeKey) {
      const typeKeys = (choice?.types || []).map((value) => normalizeText(value));
      if (!typeKeys.includes(typeKey)) return false;
    }
    return true;
  };
  const renderOrderFilterOptions = ({ keepSelection = true } = {}) => {
    const allChoices = getAvailableOrderChoices();
    const previousCategory = keepSelection ? String(orderCategoryFilter?.value || '').trim() : '';
    const previousType = keepSelection ? String(orderTypeFilter?.value || '').trim() : '';

    const categories = dedupeLabels(
      allChoices.flatMap((choice) => Array.isArray(choice?.categories) ? choice.categories : [])
    ).sort((a, b) => a.localeCompare(b));
    if (orderCategoryFilter) {
      buildSelectOptions(orderCategoryFilter, categories, 'Category');
      const resolvedCategory = resolveOptionValue(categories, previousCategory);
      orderCategoryFilter.value = resolvedCategory || '';
    }

    const activeCategory = String(orderCategoryFilter?.value || '').trim();
    const types = dedupeLabels(
      allChoices
        .filter((choice) => getOrderChoiceMatchesFilters(choice, { category: activeCategory }))
        .flatMap((choice) => Array.isArray(choice?.types) ? choice.types : [])
    ).sort((a, b) => a.localeCompare(b));
    const orderedTypes = orderStockTypeLabels(types);
    if (orderTypeFilter) {
      buildSelectOptions(orderTypeFilter, orderedTypes, 'Type');
      const resolvedType = resolveOptionValue(orderedTypes, previousType);
      orderTypeFilter.value = resolvedType || '';
    }
  };
  const renderOrderPickerOptions = ({ keepSelection = true } = {}) => {
    if (!(orderItemSelect instanceof HTMLSelectElement)) return;
    const previousItem = keepSelection ? String(orderItemSelect.value || '').trim() : '';
    renderOrderFilterOptions({ keepSelection });

    const filters = {
      searchTerm: orderItemSearch?.value || '',
      category: String(orderCategoryFilter?.value || '').trim(),
      type: String(orderTypeFilter?.value || '').trim()
    };
    const allChoices = getAvailableOrderChoices();
    const matchingChoices = allChoices.filter((choice) => getOrderChoiceMatchesFilters(choice, filters));
    orderItemSelect.innerHTML = '';
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = matchingChoices.length ? 'Select available stock' : 'No matching stock';
    orderItemSelect.appendChild(placeholder);

    matchingChoices.forEach((choice) => {
      const option = document.createElement('option');
      option.value = choice.key;
      option.textContent = formatOrderChoiceLabel(choice);
      orderItemSelect.appendChild(option);
    });

    const resolvedItem = resolveOptionValue(
      matchingChoices.map((choice) => choice.key),
      previousItem
    );
    orderItemSelect.value = resolvedItem || '';
    orderItemSelect.disabled = !matchingChoices.length;
    if (addOrderItemBtn) {
      addOrderItemBtn.disabled = !isOrderUserSignedIn() || !matchingChoices.length;
    }
  };
  const updateOrderCartBadge = () => {
    const count = orderCartItems.length;
    if (orderCartCount) {
      orderCartCount.textContent = String(count);
      orderCartCount.classList.toggle('is-empty', count === 0);
    }
  };
  const renderOrderCart = () => {
    updateOrderCartBadge();
    persistOrderCartForActiveNode();
    const lookups = createAvailableOrderChoiceLookups();
    renderOrderCartSummary(lookups);
    if (!orderItemsList) return;
    orderItemsList.innerHTML = '';
    if (!orderCartItems.length) {
      const empty = document.createElement('p');
      empty.className = 'muted order-cart-empty';
      empty.textContent = 'Your cart is empty. Use the filters above to add one or more items.';
      orderItemsList.appendChild(empty);
      return;
    }

    orderCartItems.forEach((entry, index) => {
      const card = document.createElement('section');
      card.className = 'order-item-card order-cart-item';
      card.dataset.orderCartIndex = String(index);
      const safeNotes = String(entry.notes || '').trim();

      const header = document.createElement('div');
      header.className = 'order-item-card__header';
      const title = document.createElement('p');
      title.className = 'eyebrow';
      title.textContent = `Item ${index + 1}`;
      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'button ghost small';
      removeBtn.setAttribute('data-remove-cart-item', String(index));
      removeBtn.textContent = 'Remove';
      header.appendChild(title);
      header.appendChild(removeBtn);

      const meta = document.createElement('div');
      meta.className = 'order-cart-item__meta';
      const nameLine = document.createElement('p');
      const strong = document.createElement('strong');
      strong.textContent = String(entry.item || '').trim();
      nameLine.appendChild(strong);
      const formLabel = String(entry.form || '').trim();
      const nodeLabel = String(entry.node_name || '').trim();
      const quantity = parseOrderQuantity(entry.quantity) || 1;
      const pricing = resolveOrderCartEntryPricing(entry, lookups);
      const linePriceUsd = pricing.priceUsd !== null ? parsePriceUsd(pricing.priceUsd * quantity) : null;
      const lineLandUseUnits = pricing.landUseUnits !== null ? parseLandUseUnits(pricing.landUseUnits * quantity) : null;
      const quantityWrap = document.createElement('label');
      quantityWrap.className = 'order-cart-item__quantity';
      const quantityLabel = document.createElement('span');
      quantityLabel.textContent = 'Quantity';
      const quantityInput = document.createElement('input');
      quantityInput.type = 'number';
      quantityInput.min = '1';
      quantityInput.step = '1';
      quantityInput.inputMode = 'numeric';
      quantityInput.className = 'order-cart-item-qty';
      quantityInput.setAttribute('data-cart-qty-input', String(index));
      quantityInput.value = String(quantity);
      quantityLabel.appendChild(quantityInput);
      quantityWrap.appendChild(quantityLabel);
      meta.appendChild(nameLine);
      if (formLabel) {
        const formLine = document.createElement('p');
        formLine.textContent = `Form: ${formLabel}`;
        meta.appendChild(formLine);
      }
      if (!activeNodeId && nodeLabel) {
        const nodeLine = document.createElement('p');
        nodeLine.textContent = `Node: ${nodeLabel}`;
        meta.appendChild(nodeLine);
      }
      meta.appendChild(quantityWrap);
      if (pricing.priceUsd !== null) {
        const unitPriceLine = document.createElement('p');
        unitPriceLine.textContent = `Unit price: ${formatPriceDisplay(pricing.priceUsd)}`;
        meta.appendChild(unitPriceLine);
      }
      if (pricing.landUseUnits !== null) {
        const landUseUnitsLine = document.createElement('p');
        landUseUnitsLine.textContent = `Land-Use Units: ${formatLandUseUnitsDisplay(pricing.landUseUnits)} each`;
        meta.appendChild(landUseUnitsLine);
      }
      if (linePriceUsd !== null || lineLandUseUnits !== null) {
        const lineTotalLine = document.createElement('p');
        const lineTotalParts = [];
        if (linePriceUsd !== null) lineTotalParts.push(formatPriceDisplay(linePriceUsd));
        if (lineLandUseUnits !== null) {
          lineTotalParts.push(`${formatLandUseUnitsDisplay(lineLandUseUnits)} Land-Use Units`);
        }
        lineTotalLine.textContent = `Line total: ${lineTotalParts.join(' | ')}`;
        meta.appendChild(lineTotalLine);
      } else {
        const pricingPendingLine = document.createElement('p');
        pricingPendingLine.className = 'muted';
        pricingPendingLine.textContent = 'Pricing pending for this item.';
        meta.appendChild(pricingPendingLine);
      }
      if (safeNotes) {
        const notesLine = document.createElement('p');
        notesLine.textContent = `Notes: ${safeNotes}`;
        meta.appendChild(notesLine);
      }

      card.appendChild(header);
      card.appendChild(meta);
      orderItemsList.appendChild(card);
    });
  };
  const resetOrderComposer = ({ focus = false, clearCart = true } = {}) => {
    if (clearCart) orderCartItems = [];
    if (orderItemSearch) orderItemSearch.value = '';
    if (orderCategoryFilter) orderCategoryFilter.value = '';
    if (orderTypeFilter) orderTypeFilter.value = '';
    if (orderItemSelect) orderItemSelect.value = '';
    if (orderQuantityInput) orderQuantityInput.value = '';
    if (orderItemNotes) orderItemNotes.value = '';
    renderOrderPickerOptions({ keepSelection: false });
    renderOrderCart();
    if (focus) focusOrderField(orderItemSearch || orderItemSelect);
  };
  const updateOrderReferralField = () => {
    const usesExistingMember = String(orderReferralSource?.value || '') === REFERRAL_SOURCE_EXISTING_MEMBER;
    if (orderReferralMemberField) {
      orderReferralMemberField.classList.toggle('is-hidden', !usesExistingMember);
      orderReferralMemberField.hidden = !usesExistingMember;
    }
    if (orderReferralMemberName) {
      orderReferralMemberName.required = usesExistingMember;
      orderReferralMemberName.disabled = !usesExistingMember;
      if (!usesExistingMember) {
        orderReferralMemberName.value = '';
      }
    }
  };
  const resetOrderReferralFields = () => {
    if (orderReferralSource) orderReferralSource.value = '';
    if (orderReferralMemberName) orderReferralMemberName.value = '';
    updateOrderReferralField();
  };
  const refreshOrderComposerForInventory = () => {
    const lookups = createAvailableOrderChoiceLookups();
    const previousCount = orderCartItems.length;
    orderCartItems = orderCartItems
      .map((entry) => {
        const match = findMatchingOrderChoiceForEntry(entry, lookups);
        if (!match) return null;
        const pricing = normalizePricingSnapshot(match.price_usd, match.land_use_units);
        return {
          ...entry,
          item: match.name,
          form: match.form || null,
          node_id: match.node_id ?? null,
          node_name: match.node_name || null,
          choice_key: match.key,
          price_usd: pricing.priceUsd,
          land_use_units: pricing.landUseUnits
        };
      })
      .filter(Boolean);
    renderOrderPickerOptions({ keepSelection: true });
    renderOrderCart();
    if (orderStatus && previousCount > orderCartItems.length) {
      orderStatus.textContent = 'Some cart items were removed because they are no longer available at this node.';
    }
    updateOrderAccessState();
  };
  const addCurrentSelectionToCart = () => {
    if (!isOrderUserSignedIn()) {
      showOrderSignIn();
      return;
    }
    const choiceKey = String(orderItemSelect?.value || '').trim();
    const quantityValue = String(orderQuantityInput?.value || '').trim();
    const notesValue = String(orderItemNotes?.value || '').trim();
    const quantity = parseOrderQuantity(quantityValue);
    const availableChoices = getAvailableOrderChoices();
    const selectedChoice = availableChoices.find((choice) => String(choice.key) === choiceKey);

    if (!choiceKey || !selectedChoice) {
      orderStatus.textContent = 'Choose an item from the available stock list.';
      focusOrderField(orderItemSelect || orderItemSearch);
      return;
    }
    if (quantity === null) {
      orderStatus.textContent = 'Add a valid quantity before adding to cart.';
      focusOrderField(orderQuantityInput);
      return;
    }

    const allowedChoiceKeys = new Set(
      availableChoices.map((choice) => String(choice.key))
    );
    if (!allowedChoiceKeys.has(String(choiceKey))) {
      orderStatus.textContent = 'Choose items from the available stock dropdown only.';
      focusOrderField(orderItemSelect);
      return;
    }

    const pricing = normalizePricingSnapshot(selectedChoice.price_usd, selectedChoice.land_use_units);
    orderCartItems.push({
      item: selectedChoice.name,
      form: selectedChoice.form || null,
      quantity: String(quantity),
      notes: notesValue || null,
      node_id: selectedChoice.node_id ?? null,
      node_name: selectedChoice.node_name || null,
      choice_key: selectedChoice.key,
      price_usd: pricing.priceUsd,
      land_use_units: pricing.landUseUnits
    });

    if (orderQuantityInput) orderQuantityInput.value = '';
    if (orderItemNotes) orderItemNotes.value = '';
    orderStatus.textContent = `${formatOrderChoiceLabel(selectedChoice)} added to cart.`;
    renderOrderCart();
    updateOrderAccessState();
    focusOrderField(orderQuantityInput || orderItemSelect);
  };
  const setOrderPickerToItem = (itemName, preferredChoiceKey = '') => {
    const desired = String(itemName || '').trim();
    if (!desired) return false;
    if (orderItemSearch) orderItemSearch.value = '';
    if (orderCategoryFilter) orderCategoryFilter.value = '';
    if (orderTypeFilter) orderTypeFilter.value = '';
    renderOrderPickerOptions({ keepSelection: false });
    if (!(orderItemSelect instanceof HTMLSelectElement)) return false;
    const values = Array.from(orderItemSelect.options)
      .map((option) => String(option.value || '').trim())
      .filter(Boolean);
    let resolved = '';
    const preferred = String(preferredChoiceKey || '').trim();
    if (preferred && values.includes(preferred)) {
      resolved = preferred;
    } else {
      const matches = getAvailableOrderChoices()
        .filter((choice) => normalizeText(choice.name) === normalizeText(desired));
      if (matches.length) {
        resolved = matches[0].key;
      } else {
        resolved = resolveOptionValue(values, desired);
      }
    }
    if (!resolved) return false;
    orderItemSelect.value = resolved;
    return true;
  };
  const addStockTableItemToCart = (itemName, formName = '', nodeId = null, nodeName = '') => {
    const desired = String(itemName || '').trim();
    const desiredForm = String(formName || '').trim();
    if (!desired) return;
    if (!isOrderUserSignedIn()) {
      showOrderSignIn();
      return;
    }

    const choices = getAvailableOrderChoices()
      .filter((choice) => normalizeText(choice.name) === normalizeText(desired))
      .filter((choice) => normalizeText(choice.form || '') === normalizeText(desiredForm));
    let selectedChoice = null;
    if (activeNodeId) {
      selectedChoice = choices[0] || null;
    } else {
      const nodeIdKey = nodeId === undefined || nodeId === null ? '' : String(nodeId).trim();
      const nodeNameKey = normalizeText(nodeName || '');
      selectedChoice = choices.find((choice) => String(choice.node_id || '') === nodeIdKey)
        || choices.find((choice) => normalizeText(choice.node_name || '') === nodeNameKey)
        || (choices.length === 1 ? choices[0] : null);
    }
    if (!selectedChoice) {
      orderStatus.textContent = `${desired} is not currently available to order from this node.`;
      return;
    }
    const pricing = normalizePricingSnapshot(selectedChoice.price_usd, selectedChoice.land_use_units);
    orderCartItems.push({
      item: selectedChoice.name,
      form: selectedChoice.form || null,
      quantity: '1',
      notes: null,
      node_id: selectedChoice.node_id ?? null,
      node_name: selectedChoice.node_name || null,
      choice_key: selectedChoice.key,
      price_usd: pricing.priceUsd,
      land_use_units: pricing.landUseUnits
    });
    renderOrderCart();
    updateOrderAccessState();
    if (orderModal?.classList.contains('is-hidden')) return;
    orderStatus.textContent = `${formatOrderChoiceLabel(selectedChoice)} added to cart.`;
    if (setOrderPickerToItem(desired, selectedChoice.key) && orderQuantityInput && !String(orderQuantityInput.value || '').trim()) {
      orderQuantityInput.value = '1';
    }
  };
  const updateOrderAccessState = () => {
    const signedIn = isOrderUserSignedIn();
    const availableChoices = getAvailableOrderChoices();
    const hasChoices = availableChoices.length > 0;
    const hasCartItems = orderCartItems.length > 0;
    const canOpenCart = hasChoices || hasCartItems;

    updateOrderCartBadge();
    if (openOrderBtn) {
      openOrderBtn.disabled = !canOpenCart;
      const buttonLabel = !canOpenCart
        ? 'No stock available to order'
        : (signedIn ? 'Open order cart' : 'Sign in to order');
      openOrderBtn.setAttribute('aria-label', buttonLabel);
      openOrderBtn.title = buttonLabel;
    }
    if (addOrderItemBtn) addOrderItemBtn.disabled = !signedIn || !hasChoices || Boolean(orderItemSelect?.disabled);
    if (orderAuthNote) {
      const scopeLabel = activeNodeId ? 'matched node' : 'selected stock node';
      if (!signedIn) {
        orderAuthNote.textContent = `Sign in to choose from the ${scopeLabel}'s current stock.`;
      } else if (!hasChoices && !hasCartItems) {
        orderAuthNote.textContent = `No available stock can be ordered from this ${scopeLabel} right now.`;
      } else {
        orderAuthNote.textContent = `Choose one or more items from the ${scopeLabel}'s currently available stock.`;
      }
    }
  };
  const applyResponsiveTableLabels = (tableEl, rowEl) => {
    if (!(tableEl instanceof HTMLTableElement) || !(rowEl instanceof HTMLTableRowElement)) return;
    let labels = tableLabelCache.get(tableEl);
    if (!labels) {
      labels = Array.from(tableEl.querySelectorAll('thead th')).map((th) => String(th.textContent || '').trim());
      tableLabelCache.set(tableEl, labels);
    }
    tableEl.dataset.hasLabels = 'true';
    Array.from(rowEl.children).forEach((cell, index) => {
      if (cell instanceof HTMLTableCellElement && labels[index]) {
        cell.dataset.label = labels[index];
      }
    });
  };
  const buildSelectOptions = (selectEl, values, allLabel) => {
    if (!selectEl) return;
    const previous = String(selectEl.value || '').trim();
    selectEl.innerHTML = '';
    const allOption = document.createElement('option');
    allOption.value = '';
    allOption.textContent = allLabel;
    selectEl.appendChild(allOption);
    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      selectEl.appendChild(option);
    });
    if (previous && values.includes(previous)) {
      selectEl.value = previous;
    } else {
      selectEl.value = '';
    }
  };

  const resolveOptionValue = (values = [], preferred = '') => {
    const desiredKey = normalizeText(preferred);
    if (!desiredKey) return '';
    return values.find((value) => normalizeText(value) === desiredKey) || '';
  };

  const refreshStockFilters = ({ keepSelection = true, preferredCategory = '', preferredType = '' } = {}) => {
    if (!stockCategoryFilter || !stockTypeFilter) return;

    const previousCategory = keepSelection ? String(stockCategoryFilter.value || '').trim() : '';
    const previousType = keepSelection ? String(stockTypeFilter.value || '').trim() : '';

    const categoriesFromCurrent = Array.from(new Set(
      allCurrent.flatMap((item) => getItemCategories(item))
    )).sort((a, b) => a.localeCompare(b));
    const categoriesFromCatalog = Array.from(new Set(
      displayStockCatalog
        .map((group) => String(group?.category || '').trim())
        .filter(Boolean)
    )).sort((a, b) => a.localeCompare(b));
    const categories = categoriesFromCurrent.length ? categoriesFromCurrent : categoriesFromCatalog;
    buildSelectOptions(stockCategoryFilter, categories, 'All categories');

    const resolvedCategory = resolveOptionValue(categories, preferredCategory || previousCategory);
    if (resolvedCategory) {
      stockCategoryFilter.value = resolvedCategory;
    }

    const activeCategory = String(stockCategoryFilter.value || '').trim();
    const typesFromCurrent = Array.from(new Set(
      allCurrent
        .filter((item) => {
          if (!activeCategory) return true;
          const itemCategories = getItemCategories(item).map((value) => normalizeText(value));
          return itemCategories.includes(normalizeText(activeCategory));
        })
        .flatMap((item) => getItemTypes(item))
    )).sort((a, b) => a.localeCompare(b));
    const typesFromCatalog = Array.from(new Set(
      displayStockCatalog
        .filter((group) => {
          const categoryLabel = String(group?.category || '').trim();
          if (!activeCategory) return true;
          return normalizeText(categoryLabel) === normalizeText(activeCategory);
        })
        .flatMap((group) => Array.isArray(group?.options) ? group.options : [])
        .map((option) => String(option || '').trim())
        .filter(Boolean)
    )).sort((a, b) => a.localeCompare(b));
    const types = typesFromCurrent.length ? typesFromCurrent : typesFromCatalog;
    const orderedTypes = orderStockTypeLabels(types);
    buildSelectOptions(stockTypeFilter, orderedTypes, 'All types');

    const resolvedType = resolveOptionValue(orderedTypes, preferredType || previousType);
    if (resolvedType) {
      stockTypeFilter.value = resolvedType;
    }
  };

  const parseNodeCounty = (node) => {
    return String(
      node?.mailing_county
      || node?.county
      || node?.mailing_city
      || node?.city
      || ''
    ).trim();
  };

  const parseNodeState = (node) => {
    return String(node?.mailing_state || node?.state || '').trim();
  };

  const toAreaKey = (county, state) => `${normalizeText(county)}::${normalizeText(state)}`;

  const getField = (obj, ...keys) => {
    for (const key of keys) {
      if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') return obj[key];
    }
    return '';
  };

  const resolveStockPricing = (item = {}) => {
    return normalizePricingSnapshot(
      getField(item, 'price_usd'),
      getField(item, 'land_use_units')
    );
  };

  const formatPriceDisplay = (value) => {
    const priceUsd = parsePriceUsd(value);
    if (priceUsd === null) return '';
    return `$${priceUsd.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: STOCK_DISPLAY_DECIMALS
    })}`;
  };

  const formatLandUseUnitsDisplay = (value) => {
    const landUseUnits = parseLandUseUnits(value);
    if (landUseUnits === null) return '';
    return landUseUnits.toFixed(STOCK_DISPLAY_DECIMALS).replace(/\.?0+$/, '');
  };

  const setResultsVisible = (visible) => {
    resultSections.forEach((section) => {
      section.classList.toggle('is-hidden', !visible);
    });
    stockSelectorPanel.classList.toggle('is-hidden', visible);
    stockFloatingActions?.classList.toggle('is-hidden', !visible);
  };
  const setCurrentNodeColumnVisible = (visible) => {
    if (!(currentTable instanceof HTMLTableElement)) return;
    const display = visible ? '' : 'none';
    const headerCell = currentTable.querySelector('thead th[data-role="stock-node-col"]');
    if (headerCell instanceof HTMLElement) headerCell.style.display = display;
    currentTable.querySelectorAll('tbody td[data-role="stock-node-col"]').forEach((cell) => {
      if (cell instanceof HTMLElement) cell.style.display = display;
    });
  };

  const formatNodeLabel = (node, idx = 0) => {
    const name = node?.name || node?.label || `Node ${node?.id || idx + 1}`;
    const city = node?.mailing_city || node?.city || '';
    const state = parseNodeState(node);
    const county = parseNodeCounty(node);
    const area = [county || city, state].filter(Boolean).join(', ');
    return area ? `${name} (${area})` : name;
  };

  const renderCurrent = () => {
    currentBody.innerHTML = '';
    const term = (currentSearch?.value || '').trim().toLowerCase();
    const selectedCategory = normalizeText(stockCategoryFilter?.value || '');
    const selectedType = normalizeText(stockTypeFilter?.value || '');
    const showNodeColumn = !activeNodeId;
    setCurrentNodeColumnVisible(showNodeColumn);

    const facetFiltered = allCurrent.filter((item) => {
      if (selectedCategory) {
        const categories = getItemCategories(item).map((value) => normalizeText(value));
        if (!categories.includes(selectedCategory)) return false;
      }
      if (selectedType) {
        const types = getItemTypes(item).map((value) => normalizeText(value));
        if (!types.includes(selectedType)) return false;
      }
      return true;
    });

    const filtered = !term
      ? facetFiltered
      : facetFiltered.filter((item) => {
          const itemName = String(item?.item || '').toLowerCase();
          const itemType = getItemTypes(item).join(' ').toLowerCase();
          const itemCategories = getItemCategories(item).join(' ').toLowerCase();
          const itemForms = getItemForms(item).join(' ').toLowerCase();
          const nodeName = String(item?.node_name || '').toLowerCase();
          return itemName.includes(term) || itemType.includes(term) || itemCategories.includes(term) || itemForms.includes(term) || nodeName.includes(term);
        });

    if (!filtered.length) {
      currentStatus.textContent = 'No stock matches the selected filters.';
      return;
    }

    let firstHighlightedRow = null;
    filtered.forEach((item) => {
      const tr = document.createElement('tr');
      const categories = getItemCategories(item).join(', ');
      const formsMarkup = formatItemForms(item);
      const typeMarkup = getItemTypes(item)
        .map((typeLabel) => `<span class="pill-sand">${escapeHtml(typeLabel)}</span>`)
        .join('');
      const priceMarkup = formatItemPrices(item);
      const landUseUnitsMarkup = formatItemLandUseUnits(item);
      const name = item?.item || '';
      const safeName = escapeHtml(name);
      const normalizedItem = normalizeName(name);
      const nodeIdRaw = item?.node_id;
      const nodeId = nodeIdRaw === undefined || nodeIdRaw === null || String(nodeIdRaw).trim() === '' ? '' : String(nodeIdRaw).trim();
      const nodeLabel = String(item?.node_name || '').trim() || 'Global Listing';
      const safeNodeLabel = escapeHtml(nodeLabel);
      const safeCategories = escapeHtml(categories || '');
      const encodedNodeId = nodeId ? encodeURIComponent(nodeId) : '';
      const encodedNodeName = nodeLabel ? encodeURIComponent(nodeLabel) : '';
      const quickAddButtons = getItemFormEntries(item)
        .filter((entry) => String(entry?.form || '').trim() && toStockCount(entry?.stock_left) > 0)
        .map((entry) => {
          const encodedOrderItem = name ? encodeURIComponent(name) : '';
          const encodedForm = encodeURIComponent(String(entry.form || '').trim());
          return `
            <button
              type="button"
              class="button ghost small stock-row-cart-btn"
              data-add-stock-item="${encodedOrderItem}"
              data-add-stock-form="${encodedForm}"
              data-add-stock-node-id="${encodedNodeId}"
              data-add-stock-node-name="${encodedNodeName}"
              aria-label="Add ${escapeHtml(String(entry.form || '').trim())} to cart"
            >
              Add ${escapeHtml(String(entry.form || '').trim())}
            </button>
          `;
        })
        .join('');
      const link = name
        ? `<a href="plants.html?focus=1&q=${encodeURIComponent(name)}">${safeName}</a>`
        : '';

      tr.innerHTML = `
        <td>${link}</td>
        <td data-role="stock-node-col">${safeNodeLabel}</td>
        <td>${safeCategories}</td>
        <td data-role="stock-form-col">${formsMarkup || ''}</td>
        <td>${typeMarkup ? `<div class="pill-row">${typeMarkup}</div>` : ''}</td>
        <td data-role="stock-price-col">${priceMarkup}</td>
        <td data-role="stock-land-use-units-col">${landUseUnitsMarkup}</td>
        <td data-role="stock-order-col">${quickAddButtons}</td>
      `;
      applyResponsiveTableLabels(currentTable, tr);
      currentBody.appendChild(tr);

      if (highlightTarget && normalizedItem === highlightTarget) {
        tr.classList.add('highlighted-stock');
        if (!firstHighlightedRow) firstHighlightedRow = tr;
      }
    });
    if (!highlightApplied && firstHighlightedRow) {
      highlightApplied = true;
      setTimeout(() => firstHighlightedRow.scrollIntoView({ behavior: 'smooth', block: 'center' }), 50);
    }
    setCurrentNodeColumnVisible(showNodeColumn);

    const activeFilters = [];
    if (stockCategoryFilter?.value) activeFilters.push(`Category: ${stockCategoryFilter.value}`);
    if (stockTypeFilter?.value) activeFilters.push(`Type: ${stockTypeFilter.value}`);
    currentStatus.textContent = activeFilters.length
      ? `Showing ${filtered.length} stock item(s) (${activeFilters.join(' | ')}).`
      : `Showing ${filtered.length} stock item(s).`;
  };

  const renderExchange = () => {
    exchangeBody.innerHTML = '';
    const term = (exchangeSearch?.value || '').trim().toLowerCase();
    const filtered = !term
      ? allExchange
      : allExchange.filter((item) => {
          const itemName = String(item?.item || '').toLowerCase();
          const tradedFor = String(item?.traded_for || '').toLowerCase();
          return itemName.includes(term) || tradedFor.includes(term);
        });

    if (!filtered.length) {
      exchangeStatus.textContent = 'No exchanges match that search.';
      return;
    }

    filtered.forEach((item) => {
      const tr = document.createElement('tr');
      const when = item?.created_at;
      const itemName = item?.item;
      const tradedFor = item?.traded_for;
      let whenDisplay = when;
      try {
        const date = new Date(when);
        if (!Number.isNaN(date.getTime())) whenDisplay = date.toLocaleString();
      } catch (_err) {
        // keep original value
      }

      tr.innerHTML = `
        <td>${escapeHtml(whenDisplay)}</td>
        <td>${escapeHtml(itemName)}</td>
        <td>${escapeHtml(tradedFor)}</td>
      `;
      applyResponsiveTableLabels(exchangeTable, tr);
      exchangeBody.appendChild(tr);
    });

    exchangeStatus.textContent = `Showing ${filtered.length} exchange(s). Last updated ${new Date().toLocaleString()}.`;
  };

  const loadCurrentStock = async () => {
    try {
      const query = new URLSearchParams();
      if (activeNodeId) query.set('node_id', String(activeNodeId));
      const list = await jsonFetch(`/api/stock/current${query.toString() ? `?${query.toString()}` : ''}`);
      allCurrent = (Array.isArray(list) ? list : []).sort((a, b) => {
        const itemDiff = String(a?.item || '').localeCompare(String(b?.item || ''));
        if (itemDiff !== 0) return itemDiff;
        return String(a?.node_name || '').localeCompare(String(b?.node_name || ''));
      });
      refreshOrderComposerForInventory();
      updateOrderAccessState();
      if (applyNeedFiltersOnNextLoad && selectedStockNeed) {
        refreshStockFilters({
          keepSelection: false,
          preferredCategory: selectedStockNeed.category || '',
          preferredType: selectedStockNeed.label || ''
        });
      } else if (applyQueryFiltersOnNextLoad && (queryCategory || queryType)) {
        refreshStockFilters({
          keepSelection: false,
          preferredCategory: queryCategory || '',
          preferredType: queryType || ''
        });
      } else {
        refreshStockFilters({ keepSelection: true });
      }
      applyNeedFiltersOnNextLoad = false;
      applyQueryFiltersOnNextLoad = false;
      if (!allCurrent.length) {
        currentBody.innerHTML = '';
        currentStatus.textContent = 'No stock recorded yet.';
        return;
      }
      renderCurrent();
    } catch (err) {
      console.error('loadCurrentStock error:', err);
      currentStatus.textContent = 'Failed to load current stock.';
      refreshOrderComposerForInventory();
      updateOrderAccessState();
    }
  };

  const loadExchangeStock = async () => {
    try {
      const query = new URLSearchParams();
      if (activeNodeId) query.set('node_id', String(activeNodeId));
      if (queryItem) query.set('q', queryItem);
      const list = await jsonFetch(`/api/stock/exchange${query.toString() ? `?${query.toString()}` : ''}`);
      allExchange = Array.isArray(list) ? list : [];
      if (!allExchange.length) {
        exchangeBody.innerHTML = '';
        exchangeStatus.textContent = 'No exchanges recorded yet.';
        return;
      }
      renderExchange();
    } catch (err) {
      console.error('loadExchangeStock error:', err);
      exchangeStatus.textContent = 'Failed to load exchange history.';
    }
  };

  const fillNodeSelect = (selectEl) => {
    if (!selectEl) return;
    selectEl.innerHTML = '';
    const allOption = document.createElement('option');
    allOption.value = '';
    allOption.textContent = 'All Stock Nodes';
    selectEl.appendChild(allOption);
    nodesCache.forEach((node, idx) => {
      const option = document.createElement('option');
      option.value = String(node.id || '');
      option.textContent = formatNodeLabel(node, idx);
      selectEl.appendChild(option);
    });
    if (activeNodeId) selectEl.value = String(activeNodeId);
    else selectEl.value = '';
  };

  const setActiveNode = (nodeId) => {
    const nextNodeId = nodeId ? String(nodeId) : null;
    const changed = nextNodeId !== activeNodeId;
    activeNodeId = nextNodeId;
    if (currentNodeSelect) currentNodeSelect.value = activeNodeId || '';
    if (exchangeNodeSelect) exchangeNodeSelect.value = activeNodeId || '';
    setCurrentNodeColumnVisible(!activeNodeId);
    if (changed) {
      loadOrderCartForActiveNode();
      renderOrderCart();
      renderOrderPickerOptions({ keepSelection: false });
      updateOrderAccessState();
    }
  };

  const buildLocationAreas = (nodes) => {
    const grouped = new Map();
    nodes.forEach((node) => {
      const county = parseNodeCounty(node);
      const state = parseNodeState(node);
      if (!county || !state) return;
      const key = toAreaKey(county, state);
      if (!grouped.has(key)) {
        grouped.set(key, { key, county, state, nodes: [] });
      }
      grouped.get(key).nodes.push(node);
    });
    return Array.from(grouped.values()).sort((a, b) => {
      if (a.state !== b.state) return a.state.localeCompare(b.state);
      return a.county.localeCompare(b.county);
    });
  };

  const renderLocationOptions = () => {
    locationAreaByKey.clear();
    stockLocationSelect.innerHTML = '';
    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = locationAreas.length ? 'Select county, state' : 'No county/state locations available';
    placeholder.selected = true;
    stockLocationSelect.appendChild(placeholder);

    locationAreas.forEach((area) => {
      const option = document.createElement('option');
      option.value = area.key;
      option.textContent = `${area.county}, ${area.state}`;
      stockLocationSelect.appendChild(option);
      locationAreaByKey.set(area.key, area);
    });

    stockConfirmLocationBtn.disabled = !locationAreas.length;
  };

  const renderSpecialtyGrid = () => {
    stockSpecialtyGrid.innerHTML = '';
    specialtyById = new Map();
    displayStockCatalog.forEach((category, categoryIdx) => {
      const categoryLabel = String(category?.category || '').trim();
      if (!categoryLabel) return;
      const availableOptions = (category.options || [])
        .map((rawLabel) => String(rawLabel || '').trim())
        .filter(Boolean);
      if (!availableOptions.length) return;

      const card = document.createElement('article');
      card.className = 'specialty-group-card';
      const heading = document.createElement('h3');
      heading.textContent = categoryLabel;
      card.appendChild(heading);

      const optionsWrap = document.createElement('div');
      optionsWrap.className = 'specialty-group-card__options';
      availableOptions.forEach((label, optionIdx) => {
        const lbl = String(label || '').trim();
        const specialty = {
          id: `stock-${categoryIdx}-${optionIdx}-${toSlug(categoryLabel)}-${toSlug(lbl)}`,
          mode: 'stock',
          category: categoryLabel,
          label: lbl
        };
        specialtyById.set(specialty.id, specialty);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'specialty-choice-button';
        button.dataset.optionId = specialty.id;
        const labelSpan = document.createElement('span');
        labelSpan.textContent = lbl;
        button.appendChild(labelSpan);
        optionsWrap.appendChild(button);
      });
      card.appendChild(optionsWrap);
      stockSpecialtyGrid.appendChild(card);
    });
  };

  const openLocationModal = (specialty) => {
    pendingSpecialty = specialty;
    stockLocationStatus.textContent = '';
    stockLocationSelect.value = '';
    stockLocationModal.classList.remove('is-hidden');
  };

  const closeLocationModal = () => {
    stockLocationModal.classList.add('is-hidden');
  };

  const applyMatchedContext = async () => {
    if (!matchedNode || !selectedSpecialty) return;
    selectedStockNeed = {
      category: selectedSpecialty.category || '',
      label: selectedSpecialty.label || ''
    };
    setActiveNode(matchedNode.id || null);
    fillNodeSelect(currentNodeSelect);
    fillNodeSelect(exchangeNodeSelect);
    const needLabel = selectedSpecialty.label || 'your selected stock needs';
    const areaLabel = selectedArea
      ? `${selectedArea.county}${selectedArea.state ? `, ${selectedArea.state}` : ''}`
      : 'your location';
    stockMatchSummary.textContent = `Matched with ${formatNodeLabel(matchedNode)} for ${selectedSpecialty.category}: ${needLabel} in ${areaLabel}.`;
    setResultsVisible(true);
    applyNeedFiltersOnNextLoad = true;
    if (currentSearch) currentSearch.value = '';
    await loadCurrentStock();
    loadExchangeStock();
    currentBody.closest('section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const url = new URL(window.location.href);
    if (matchedNode.id != null) url.searchParams.set('node_id', String(matchedNode.id));
    if (selectedSpecialty.category) url.searchParams.set('category', selectedSpecialty.category);
    if (selectedSpecialty.label) url.searchParams.set('type', selectedSpecialty.label);
    url.searchParams.set('item', selectedSpecialty.label);
    window.history.replaceState({}, '', `${url.pathname}?${url.searchParams.toString()}`);
  };

  const parseApiError = (err) => {
    const message = String(err?.message || '').trim();
    if (!message) return 'Unable to match a stock node right now. Please try again.';
    return message;
  };

  const hasConfiguredStockSpecialty = (specialty) => {
    if (!specialty) return false;
    return nodesCache.some((node) => nodeMatchesSpecialty(node, {
      mode: 'stock',
      category: specialty.category,
      option: specialty.label,
      allowGeneric: false
    }));
  };

  const showStockUnavailablePopup = () => {
    if (!stockSelectorPanel) return;
    const existing = stockSelectorPanel.querySelector('.mini-popup[data-role="stock-unavailable"]');
    if (existing) existing.remove();
    const popup = document.createElement('div');
    popup.className = 'mini-popup';
    popup.dataset.role = 'stock-unavailable';
    popup.textContent = 'Sorry, we dont have that in stock yet. Please check back again soon!';
    stockSelectorPanel.appendChild(popup);
    window.setTimeout(() => popup.remove(), 4500);
  };

  const requestNodeMatch = async ({ county = '', state = '', lat = null, lng = null, label = '' } = {}) => {
    if (!pendingSpecialty) return;
    stockLocationStatus.textContent = 'Finding the best matching node...';
    const query = new URLSearchParams({
      mode: 'stock',
      category: pendingSpecialty.category || '',
      option: pendingSpecialty.label || ''
    });
    if (county && state) {
      query.set('county', county);
      query.set('state', state);
    }
    if (lat != null && lng != null) {
      query.set('lat', String(lat));
      query.set('lng', String(lng));
      query.set('max_miles', '50');
    }

    try {
      const result = await jsonFetch(`/api/nodes/match?${query.toString()}`);
      matchedNode = result?.node || null;
      if (!matchedNode) throw new Error('No matching node returned.');
      selectedSpecialty = pendingSpecialty;
      selectedArea = county && state
        ? { county, state }
        : { county: label || 'Current Location', state: '' };
      closeLocationModal();
      stockSelectorStatus.textContent = '';
      await applyMatchedContext();
    } catch (err) {
      stockLocationStatus.textContent = parseApiError(err);
    }
  };

  const loadNodeDirectory = async () => {
    stockSelectorStatus.textContent = 'Loading stock node locations...';
    let loadFailed = false;
    try {
      const nodes = await jsonFetch('/api/nodes?public=1');
      nodesCache = (Array.isArray(nodes) ? nodes : []).filter((node) => nodeSupportsStockDirectory(node));
    } catch (err) {
      console.error('load nodes error:', err);
      nodesCache = [];
      loadFailed = true;
    }

    // The questionnaire tree comes from the specialization catalog, not reconstructed inventory.
    displayStockCatalog = buildCatalogWithConfiguredSpecialties(stockCatalog, nodesCache, 'stock', { includeBaseCatalog: true });

    renderSpecialtyGrid();

    if (!nodesCache.length) {
      stockSelectorStatus.textContent = loadFailed
        ? 'Unable to load Stock Nodes right now. Please refresh and try again.'
        : 'No Stock Nodes are available yet.';
      locationAreas = [];
      renderLocationOptions();
      return;
    }

    if (!specialtyById.size) {
      stockSelectorStatus.textContent = 'No stock specialties are configured yet.';
    }

    const fromQuery = nodesCache.find((node) => String(node.id) === String(queryNode));
    if (fromQuery) {
      matchedNode = fromQuery;
      setActiveNode(fromQuery.id || null);
    } else if (!activeNodeId && nodesCache.length && !shouldOpenResultsFromQuery) {
      setActiveNode(nodesCache[0].id || null);
    }

    fillNodeSelect(currentNodeSelect);
    fillNodeSelect(exchangeNodeSelect);
    locationAreas = buildLocationAreas(nodesCache);
    renderLocationOptions();
    refreshStockFilters({ keepSelection: true });
    if (specialtyById.size) stockSelectorStatus.textContent = '';
  };

  const closeModal = (modal) => modal?.classList.add('is-hidden');
  const openModal = (modal) => modal?.classList.remove('is-hidden');

  const wireOrderModal = () => {
    if (!orderModal || !orderForm) return;

    orderItemSearch?.addEventListener('input', () => {
      orderStatus.textContent = '';
      renderOrderPickerOptions({ keepSelection: true });
    });
    orderCategoryFilter?.addEventListener('change', () => {
      orderStatus.textContent = '';
      if (orderTypeFilter) orderTypeFilter.value = '';
      renderOrderPickerOptions({ keepSelection: true });
    });
    orderTypeFilter?.addEventListener('change', () => {
      orderStatus.textContent = '';
      renderOrderPickerOptions({ keepSelection: true });
    });
    orderReferralSource?.addEventListener('change', () => {
      orderStatus.textContent = '';
      updateOrderReferralField();
    });

    openOrderBtn?.addEventListener('click', () => {
      orderStatus.textContent = '';
      if (!isOrderUserSignedIn()) {
        showOrderSignIn();
        return;
      }
      const hasChoices = getAvailableOrderChoices().length > 0;
      if (!hasChoices && !orderCartItems.length) {
        orderStatus.textContent = 'No available stock can be ordered from this matched node right now.';
        return;
      }
      openModal(orderModal);
      resetOrderComposer({ focus: true, clearCart: false });
    });

    addOrderItemBtn?.addEventListener('click', () => {
      addCurrentSelectionToCart();
    });

    const syncCartQuantityInput = (target) => {
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.matches('[data-cart-qty-input]')) return;
      const idx = Number(target.getAttribute('data-cart-qty-input'));
      if (!Number.isInteger(idx) || idx < 0 || idx >= orderCartItems.length) return;
      const normalizedQty = String(parseOrderQuantity(target.value) || 1);
      target.value = normalizedQty;
      orderCartItems[idx].quantity = normalizedQty;
      orderStatus.textContent = '';
      renderOrderCart();
    };

    orderItemsList?.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const removeBtn = event.target.closest('[data-remove-cart-item]');
      if (!removeBtn) return;
      const idx = Number(removeBtn.getAttribute('data-remove-cart-item'));
      if (!Number.isInteger(idx) || idx < 0 || idx >= orderCartItems.length) return;
      orderCartItems.splice(idx, 1);
      orderStatus.textContent = '';
      renderOrderCart();
    });
    orderItemsList?.addEventListener('change', (event) => {
      syncCartQuantityInput(event.target);
    });

    orderModal.addEventListener('click', (event) => {
      if (event.target === orderModal) closeModal(orderModal);
    });

    document.querySelectorAll('[data-close-modal="orderModal"]').forEach((btn) => {
      btn.addEventListener('click', () => closeModal(orderModal));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !orderModal.classList.contains('is-hidden')) {
        closeModal(orderModal);
      }
    });

    orderForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      orderStatus.textContent = '';

      if (!isOrderUserSignedIn()) {
        showOrderSignIn();
        return;
      }

      const availableChoices = getAvailableOrderChoices();
      const orderChoiceLookups = createAvailableOrderChoiceLookups(availableChoices);
      const allowedChoiceKeys = new Set(availableChoices.map((choice) => String(choice.key)));
      const allowedNames = new Set(availableChoices.map((choice) => normalizeText(choice.name)));
      const referralSource = String(orderReferralSource?.value || '').trim();
      const usesExistingMemberReferral = referralSource === REFERRAL_SOURCE_EXISTING_MEMBER;
      const referralMemberName = String(orderReferralMemberName?.value || '').trim();
      if (!referralSource) {
        orderStatus.textContent = 'Please choose how you found us.';
        focusOrderField(orderReferralSource);
        return;
      }
      if (usesExistingMemberReferral && !referralMemberName) {
        orderStatus.textContent = 'Please enter the existing member name so they receive credit.';
        focusOrderField(orderReferralMemberName);
        return;
      }
      if (!orderCartItems.length) {
        orderStatus.textContent = 'Add at least one item to your cart before sending.';
        focusOrderField(orderItemSelect || orderItemSearch);
        return;
      }
      const invalidItem = orderCartItems.find((entry) => {
        const choiceKey = String(entry.choice_key || '').trim();
        if (choiceKey) return !allowedChoiceKeys.has(choiceKey);
        return !allowedNames.has(normalizeText(entry.item))
          || !findMatchingOrderChoiceForEntry(entry, orderChoiceLookups);
      });
      if (invalidItem) {
        orderStatus.textContent = 'One or more cart items are no longer in available stock. Please review your cart.';
        refreshOrderComposerForInventory();
        return;
      }

      const items = orderCartItems.map((entry) => {
        const pricing = resolveOrderCartEntryPricing(entry, orderChoiceLookups);
        return {
          item: String(entry.item || '').trim(),
          form: String(entry.form || '').trim() || null,
          quantity: String(parseOrderQuantity(entry.quantity) || ''),
          notes: String(entry.notes || '').trim() || null,
          node_id: entry.node_id ?? null,
          node_name: entry.node_name || null,
          price_usd: pricing.priceUsd,
          land_use_units: pricing.landUseUnits
        };
      });
      const cartTotals = calculateOrderCartTotals(orderChoiceLookups);

      if (items.some((entry) => !entry.item || !entry.quantity)) {
        orderStatus.textContent = 'Each cart item must include an item and quantity.';
        return;
      }
      const isAllNodesRequest = !activeNodeId;
      const requestedNodeNames = Array.from(new Set(
        items
          .map((entry) => String(entry.node_name || '').trim())
          .filter(Boolean)
      ));
      const requestedNodeName = requestedNodeNames.join(', ');
      if (isAllNodesRequest && !requestedNodeName) {
        orderStatus.textContent = 'Choose a stock row with a node label before ordering from All Stock Nodes.';
        return;
      }

      try {
        await jsonFetch('/api/orders', {
          method: 'POST',
          body: JSON.stringify({
            items,
            node_id: activeNodeId || null,
            node_name: isAllNodesRequest ? requestedNodeName : null,
            all_nodes: isAllNodesRequest,
            total_price_usd: cartTotals.itemsMissingPricing ? null : cartTotals.totalPriceUsd,
            total_land_use_units: cartTotals.itemsMissingPricing ? null : cartTotals.totalLandUseUnits,
            referral_source: referralSource,
            referral_member_name: usesExistingMemberReferral ? referralMemberName : ''
          })
        });
        orderStatus.textContent = ORDER_FOLLOW_UP_MESSAGE;
        resetOrderReferralFields();
        resetOrderComposer();
      } catch (err) {
        console.error('submit order error:', err);
        orderStatus.textContent = err?.message === 'Sign in required.'
          ? 'Sign in to place an order.'
          : 'Failed to send order. Please try again.';
      }
    });
  };

  stockSpecialtyGrid.addEventListener('click', (event) => {
    const button = event.target.closest('button[data-option-id]');
    if (!button) return;
    const specialty = specialtyById.get(button.dataset.optionId);
    if (!specialty) return;
    if (!nodesCache.length) {
      stockSelectorStatus.textContent = 'No Stock Nodes are available yet.';
      return;
    }
    if (!hasConfiguredStockSpecialty(specialty)) {
      showStockUnavailablePopup();
      return;
    }
    openLocationModal(specialty);
  });

  stockConfirmLocationBtn.addEventListener('click', async () => {
    const key = stockLocationSelect.value;
    const area = locationAreaByKey.get(key);
    if (!area) {
      stockLocationStatus.textContent = 'Select a county and state first.';
      return;
    }
    await requestNodeMatch({ county: area.county, state: area.state });
  });

  stockUseCurrentLocationBtn.addEventListener('click', () => {
    if (!navigator.geolocation) {
      stockLocationStatus.textContent = 'Current location is not supported on this device.';
      return;
    }
    stockLocationStatus.textContent = 'Getting your current location...';
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        await requestNodeMatch({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          label: 'Current Location'
        });
      },
      () => {
        stockLocationStatus.textContent = 'Unable to get your current location. Please choose county and state instead.';
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 }
    );
  });

  closeStockLocationModal?.addEventListener('click', closeLocationModal);
  cancelStockLocationBtn?.addEventListener('click', closeLocationModal);
  stockLocationModal?.addEventListener('click', (event) => {
    if (event.target === stockLocationModal) closeLocationModal();
  });

  changeStockSelectionBtn?.addEventListener('click', () => {
    selectedStockNeed = null;
    selectedSpecialty = null;
    pendingSpecialty = null;
    applyNeedFiltersOnNextLoad = false;
    if (stockCategoryFilter) stockCategoryFilter.value = '';
    if (stockTypeFilter) stockTypeFilter.value = '';
    if (currentSearch) currentSearch.value = '';
    setResultsVisible(false);
    stockSelectorStatus.textContent = '';
  });

  currentSearch?.addEventListener('input', renderCurrent);
  currentBody.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const addBtn = event.target.closest('[data-add-stock-item]');
    if (!(addBtn instanceof HTMLButtonElement)) return;
    const encoded = String(addBtn.dataset.addStockItem || '').trim();
    const encodedForm = String(addBtn.dataset.addStockForm || '').trim();
    const encodedNodeId = String(addBtn.dataset.addStockNodeId || '').trim();
    const encodedNodeName = String(addBtn.dataset.addStockNodeName || '').trim();
    if (!encoded) return;
    let itemName = '';
    let formName = '';
    let nodeId = null;
    let nodeName = '';
    try {
      itemName = decodeURIComponent(encoded);
    } catch (_err) {
      itemName = encoded;
    }
    try {
      formName = encodedForm ? decodeURIComponent(encodedForm) : '';
    } catch (_err) {
      formName = encodedForm || '';
    }
    try {
      nodeId = encodedNodeId ? decodeURIComponent(encodedNodeId) : null;
    } catch (_err) {
      nodeId = encodedNodeId || null;
    }
    try {
      nodeName = encodedNodeName ? decodeURIComponent(encodedNodeName) : '';
    } catch (_err) {
      nodeName = encodedNodeName || '';
    }
    addStockTableItemToCart(itemName, formName, nodeId, nodeName);
  });
  stockCategoryFilter?.addEventListener('change', () => {
    refreshStockFilters({ keepSelection: true });
    renderCurrent();
  });
  stockTypeFilter?.addEventListener('change', renderCurrent);
  clearStockFiltersBtn?.addEventListener('click', () => {
    if (stockCategoryFilter) stockCategoryFilter.value = '';
    refreshStockFilters({ keepSelection: true });
    if (stockTypeFilter) stockTypeFilter.value = '';
    renderCurrent();
  });
  exchangeSearch?.addEventListener('input', renderExchange);

  const handleNodeChange = async (event) => {
    setActiveNode(event.target.value || null);
    await loadCurrentStock();
    loadExchangeStock();
  };
  currentNodeSelect?.addEventListener('change', handleNodeChange);
  exchangeNodeSelect?.addEventListener('change', handleNodeChange);

  wireOrderModal();
  loadOrderCartForActiveNode();
  resetOrderReferralFields();
  resetOrderComposer({ clearCart: false });
  updateOrderAccessState();
  window.addEventListener('storage', () => {
    loadOrderCartForActiveNode();
    renderOrderCart();
    updateOrderAccessState();
  });
  renderSpecialtyGrid();
  if (shouldOpenResultsFromQuery && !queryNode) {
    queryResultsBootstrapped = true;
    if (stockMatchSummary) stockMatchSummary.textContent = 'Showing stock across all nodes.';
    setResultsVisible(true);
    loadCurrentStock();
    loadExchangeStock();
  } else {
    setResultsVisible(false);
  }

  loadNodeDirectory().then(async () => {
    if (queryNode && matchedNode) {
      if (queryCategory && (queryType || queryItem)) {
        selectedSpecialty = { category: queryCategory, label: queryType || queryItem };
        selectedArea = {
          county: parseNodeCounty(matchedNode) || (matchedNode.mailing_city || ''),
          state: parseNodeState(matchedNode)
        };
        await applyMatchedContext();
        return;
      }

      setActiveNode(matchedNode.id || null);
      fillNodeSelect(currentNodeSelect);
      fillNodeSelect(exchangeNodeSelect);
      setResultsVisible(true);
      await loadCurrentStock();
      loadExchangeStock();
      return;
    }

    if (!shouldOpenResultsFromQuery) return;
    if (queryResultsBootstrapped) return;

    if (queryNode && !matchedNode && stockMatchSummary) {
      stockMatchSummary.textContent = 'Selected node was unavailable. Showing stock across all nodes.';
    } else if (stockMatchSummary) {
      stockMatchSummary.textContent = 'Showing stock across all nodes.';
    }
    setResultsVisible(true);
    await loadCurrentStock();
    loadExchangeStock();
  });
});
